// frontend/src/components/EmergencyPanel.js


import React, { useState, useEffect } from 'react';
import { FaHospital, FaFire, FaPhone, FaDirections, FaTimes, FaLocationArrow } from 'react-icons/fa';
import '../styles/EmergencyPanel.css';

const EmergencyPanel = ({ 
  isOpen, 
  onClose, 
  userLocation, 
  onShowRoute,
  onCall 
}) => {
  const [emergencies, setEmergencies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedType, setSelectedType] = useState('all');
  const [error, setError] = useState(null);

  // ✅ Debug
  console.log('📍 EmergencyPanel - onShowRoute:', onShowRoute);
  console.log('📍 EmergencyPanel - onCall:', onCall);
  console.log('📍 EmergencyPanel - userLocation:', userLocation);

  // ✅ Emergency Data 
  const emergencyData = {
    hospitals: [
      {
        id: 'h1',
        name_mm: 'မြစ်ကြီးနား ပြည်သူ့ဆေးရုံကြီး',
        name_en: 'Myitkyina General Hospital',
        type: 'hospital',
        lat: 25.39487,
        lng: 97.39556,
        phone: '074-12345',
        address: 'ဆွမ်ပရာဘွမ်လမ်းမကြီး၊ မြစ်ကြီးနားမြို့',
        services: ['အရေးပေါ်ခန်း', 'ခွဲစိတ်ခန်း', 'သွေးခဲဘဏ်'],
        working_hours: '24/7',
        emergency_number: '112'
      },
      {
        id: 'h2',
        name_mm: 'ဝိုင်းမော် မြို့နယ်ဆေးရုံ',
        name_en: 'Waingmaw Township Hospital',
        type: 'hospital',
        lat: 25.4000,
        lng: 97.4100,
        phone: '074-23456',
        address: 'ဝိုင်းမော်မြို့',
        services: ['အရေးပေါ်ခန်း', 'ကုသခန်း'],
        working_hours: '24/7',
        emergency_number: '112'
      },
      {
        id: 'h3',
        name_mm: 'မြတ်မွန်ဆေးရုံ',
        name_en: 'Myat Mon Hospital',
        type: 'hospital',
        lat: 25.38938,
        lng: 97.40156,
        phone: '09-xxxxxxxxx',
        address: 'သီတာရပ်ကွက်၊ မြစ်ကြီးနားမြို့',
        services: ['အရေးပေါ်ခန်း', 'ကုသခန်း'],
        working_hours: '24/7',
        emergency_number: '112'
      },
      {
        id: 'h4',
        name_mm: 'ရင်စိန် ဆေးရုံ',
        name_en: 'Yin Sein Hospital',
        type: 'hospital',
        lat: 25.38433,
        lng: 97.38165,
        phone: '09-xxxxxxxxx',
        address: 'ယုဇနရပ်ကွက်၊ မြစ်ကြီးနားမြို့',
        services: ['အရေးပေါ်ခန်း', 'ကုသခန်း'],
        working_hours: '24/7',
        emergency_number: '112'
       },
      {
        id: 'h5',
        name_mm: 'အေးသုခ ဆေးရုံ',
        name_en: 'Aye Thu Hka Hospital',
        type: 'hospital',
        lat: 25.37612,
        lng: 97.40048,
        phone: '09-xxxxxxxxx',
        address: 'ရှမ်းစုတောင်ရပ်ကွက်၊ မြစ်ကြီးနားမြို့',
        services: ['အရေးပေါ်ခန်း', 'ကုသခန်း'],
        working_hours: '24/7',
        emergency_number: '112'
      }
    ],
    fire_stations: [
      {
        id: 'f1',
        name_mm: 'ကချင်ပြည်နယ် မီးသတ်ဌာန',
        name_en: 'Kachin Fire Station',
        type: 'fire',
        lat: 25.384809,
        lng: 97.398427,
        phone: '074-12345',
        address: 'သခင်နက်ဖေလမ်း၊ မြစ်ကြီးနားမြို့',
        services: ['မီးသတ်', 'ကယ်ဆယ်ရေး'],
        working_hours: '24/7',
        emergency_number: '191'
      },
      {
        id: 'f2',
        name_mm: ' ပြည်နယ် မီးသတ်ရုံး၊ပလနကျေးရွာ',
        name_en: 'Fire Station',
        type: 'fire',
        lat: 25.474984,
        lng: 97.425841,
        phone: '074-xxxxx',
        address: 'ဆွမ်ပရာဘွမ်လမ်းမကြီး၊ပလနကျေးရွာ၊ မြစ်ကြီးနားမြို့',
        services: ['မီးသတ်', 'ကယ်ဆယ်ရေး'],
        working_hours: '24/7',
        emergency_number: '191'
      }
    ],
    police_stations: [
      {
        id: 'p1',
        name_mm: 'မြစ်ကြီးနား အမှတ်- ၁ ရဲစခန်း',
        name_en: 'Myitkyina City Police Station',
        type: 'police',
        lat: 25.386766,
        lng: 97.399678,
        phone: '074-12345',
        address: 'ဗိုလ်ချုပ်အောင်ဆန်းလမ်း၊ မြစ်ကြီးနားမြို့',
        services: ['ရဲတပ်ဖွဲ့'],
        working_hours: '24/7',
        emergency_number: '199'
      },
      {
        id: 'p2',
        name_mm: 'မြစ်ကြီးနား အမှတ်- ၂ ရဲစခန်း',
        name_en: 'Myitkyina City Police Station',
        type: 'police',
        lat: 25.377966,
        lng: 97.391901,
        phone: '074-12345',
        address: 'ခေမာသီရိရပ်ကွက်၊ မြစ်ကြီးနားမြို့',
        services: ['ရဲတပ်ဖွဲ့'],
        working_hours: '24/7',
        emergency_number: '199'
      },
      {
        id: 'p3',
        name_mm: 'မြစ်ကြီးနား အမှတ်- ၃ ရဲစခန်း',
        name_en: 'Myitkyina City Police Station',
        type: 'police',
        lat: 25.475559,
        lng: 97.425690,
        phone: '074-12345',
        address: 'ဆွမ်ပရာဘွမ်လမ်းမကြီး၊ပလနကျေးရွာ၊ မြစ်ကြီးနားမြို့',
        services: ['ရဲတပ်ဖွဲ့'],
        working_hours: '24/7',
        emergency_number: '199'
      },
      {
        id: 'p4',
        name_mm: 'ဝိုင်းမော် ရဲစခန်း',
        name_en: 'Waingmaw Police Station',
        type: 'police',
        lat: 25.3980,
        lng: 97.4080,
        phone: '074-23456',
        address: 'ဝိုင်းမော်မြို့',
        services: ['ရဲတပ်ဖွဲ့'],
        working_hours: '24/7',
        emergency_number: '199'
      }
    ],
    government_offices: [
      {
        id: 'g1',
        name_mm: 'စုပေါင်းရုံး',
        name_en: 'Myitkyina Township Administrator Office',
        type: 'government',
        lat: 25.38982,
        lng: 97.40103,
        phone: '074-2522306',
        address: 'ဧရာရပ်ကွက်၊ မြစ်ကြီးနားမြို့',
        services: ['အုပ်ချုပ်ရေး', 'ပြည်သူ့ဝန်ဆောင်မှု'],
        working_hours: '24/7',
        emergency_number: '074-2522306'
      },
      {
         id: 'g2',
        name_mm: 'မြစ်ကြီးနားမြို့ စည်ပင်သာယာရုံး',
        name_en: 'Myitkyina Municipal Office',
        type: 'government',
        lat: 25.385310,
        lng: 97.402276,
        phone: '074-23456',
        address: 'မင်းရပ်ရပ်ကွက်၊ မြစ်ကြီးနားမြို့',
        services: ['စည်ပင်သာယာ', 'ပြည်သူ့ဝန်ဆောင်မှု'],
        working_hours: '၉:၀၀ မှ ၄:၃၀ နာရီ',
        emergency_number: '074-23456'
      },
      {
        id: 'g3',
        name_mm: 'အုပ်ချုပ်ရေးမှူးရုံး၊ ပမ္မတီးရပ်ကွက်',
        name_en: "Administrator's Office, Pamma Tee Ward",
        type: 'government',
        lat: 25.36991,
        lng: 97.31941,
        phone: '09-43164464',
        address: 'ပမ္မတီးရပ်ကွက်၊ မြစ်ကြီးနားမြို့',
        services: ['အုပ်ချုပ်ရေး', 'ပြည်သူ့ဝန်ဆောင်မှု'],
        working_hours: '24/7',
        emergency_number: '09-43164464'
      },
      {
        id: 'g4',
        name_mm: 'အုပ်ချုပ်ရေးမှူးရုံး၊ ရွှေပြည်သာ ရပ်ကွက်',
        name_en: "Administrator's Office, Shwe Pyi Tar Ward",
        type: 'government',
        lat: 25.39849,
        lng: 97.32045,
        phone: '09-401576991',
        address: 'ရွှေပြည်သာရပ်ကွက်၊ မြစ်ကြီးနားမြို့',
        services: ['အုပ်ချုပ်ရေး', 'ပြည်သူ့ဝန်ဆောင်မှု'],
        working_hours: '24/7',
        emergency_number: '09-401576991'
      },
       {
        id: 'g5',
        name_mm: 'အုပ်ချုပ်ရေးမှူးရုံး၊ လွယ်ခေါကျေးရွာအုပ်စု',
        name_en: "Administrator's Office, Lawe Hkaw Ward",
        type: 'government',
        lat: 25.30231,
        lng: 97.18656,
        phone: '09-xxxxxxxx',
        address: 'လွယ်ခေါကျေးရွာအုပ်စု၊ မြစ်ကြီးနားမြို့',
        services: ['အုပ်ချုပ်ရေး', 'ပြည်သူ့ဝန်ဆောင်မှု'],
        working_hours: '24/7',
        emergency_number: '09-xxxxxxxx'
      },
      {
        id: 'g6',
        name_mm: 'အုပ်ချုပ်ရေးမှူးရုံး၊ မြို့သစ်ကြီးရပ်ကွက်',
        name_en: "Administrator's Office, Myoe Tis Kyi Ward",
        type: 'government',
        lat: 25.38381,
        lng: 97.36363,
        phone: '09-xxxxxxxx',
        address: 'မြို့သစ်ကြီးရပ်ကွက်၊ မြစ်ကြီးနားမြို့',
        services: ['အုပ်ချုပ်ရေး', 'ပြည်သူ့ဝန်ဆောင်မှု'],
        working_hours: '24/7',
        emergency_number: '09-xxxxxxxx'
      },
      {
        id: 'g7',
        name_mm: 'အုပ်ချုပ်ရေးမှူးရုံး၊ ကြက်ပေါင်ခြံရပ်ကွက်',
        name_en: "Administrator's Office, KyatPaung Chan Ward",
        type: 'government',
        lat: 25.37286,
        lng: 97.35790,
        phone: '09-xxxxxxxx',
        address: 'ကြက်ပေါင်ခြံရပ်ကွက်၊ မြစ်ကြီးနားမြို့',
        services: ['အုပ်ချုပ်ရေး', 'ပြည်သူ့ဝန်ဆောင်မှု'],
        working_hours: '24/7',
        emergency_number: '09-xxxxxxxx'
      },
       {
        id: 'g8',
        name_mm: 'အုပ်ချုပ်ရေးမှူးရုံး၊ ရမ်ပူ ရပ်ကွက်',
        name_en: "Administrator's Office, RanPu  Ward",
        type: 'government',
        lat: 25.36927,
        lng: 97.38761,
        phone: '09-xxxxxxxx',
        address: 'ရမ်ပူ ရပ်ကွက်၊ မြစ်ကြီးနားမြို့',
        services: ['အုပ်ချုပ်ရေး', 'ပြည်သူ့ဝန်ဆောင်မှု'],
        working_hours: '24/7',
        emergency_number: '09-xxxxxxxx'
      },
       {
        id: 'g9',
        name_mm: 'အုပ်ချုပ်ရေးမှူးရုံး၊ တပ်ကုန်း ရပ်ကွက်',
        name_en: "Administrator's Office, TapKone  Ward",
        type: 'government',
        lat: 25.341489,
        lng: 97.39160,
        phone: '09-xxxxxxxx',
        address: 'တပ်ကုန်း ရပ်ကွက်၊ မြစ်ကြီးနားမြို့',
        services: ['အုပ်ချုပ်ရေး', 'ပြည်သူ့ဝန်ဆောင်မှု'],
        working_hours: '24/7',
        emergency_number: '09-xxxxxxxx'
      },
      {
      id: 'g10',
        name_mm: 'အုပ်ချုပ်ရေးမှူးရုံး၊ ရွှေအိုက်ရပ်ကွက်',
        name_en: "Administrator's Office, Shwe Eaike Ward",
        type: 'government',
        lat: 25.37968,
        lng: 97.32237,
        phone: '09-259408689',
        address: 'ရွှေအိုက်ရပ်ကွက်၊ မြစ်ကြီးနားမြို့',
        services: ['အုပ်ချုပ်ရေး', 'ပြည်သူ့ဝန်ဆောင်မှု'],
        working_hours: '24/7',
        emergency_number: '09-259408689'
      }
    ],
    charity_organizations: [
      {
        id: 'c1',
        name_mm: 'ဧရာဝတီကရုဏာလူမှုကူညီရေးအသင်း (မြစ်ကြီးနား)',
        name_en: 'Ayyarwati Funeral Assistance Association',
        type: 'charity',
        lat: 25.369795,
        lng: 97.400617,
        phone: '09-259043644',
        address: 'အေးစေတီရပ်ကွက်၊ မြစ်ကြီးနားမြို့',
        services: ['နာရေးကူညီမှု', 'လူမှုကူညီမှု'],
        working_hours: '24/7',
        emergency_number: '09-259043644'
      },
      {
        id: 'c2',
        name_mm: 'ပေးဆပ်သူ',
        name_en: 'Pay Sat Thu  Funeral Assistance Association',
        type: 'charity',
        lat: 25.382221,
        lng: 97.374723,
        phone: '09-777472525',
        phone: '09-790590830',
        phone: '09-426400668',
        address: 'ရမ်ပူ ရပ်ကွက်၊ မြစ်ကြီးနားမြို့',
        services: ['နာရေးကူညီမှု', 'လူမှုကူညီမှု'],
        working_hours: '24/7',
        emergency_number: '09-777472525'
      },
      {
        id: 'c3',
        name_mm: 'နာရေးကူညီမှုအသင်း',
        name_en: 'Thama Sitta Funeral Assistance Association',
        type: 'charity',
        lat: 25.390211,
        lng: 97.360503,
        phone: '09-xxxxxxxxx',
        address: 'မြို့သစ်ကြီးရပ်ကွက်၊ မြစ်ကြီးနားမြို့',
        services: ['နာရေးကူညီမှု', 'လူမှုကူညီမှု'],
        working_hours: '24/7',
        emergency_number: '09-xxxxxxxxx'
      }
    ]
  };

   // ✅ Type Config
  const typeConfig = {
    hospital: {
      icon: <FaHospital />,
      color: '#ef4444',
      bgColor: '#fee2e2',
      label: 'ဆေးရုံ',
      iconText: '🏥'
    },
    fire: {
      icon: <FaFire />,
      color: '#f59e0b',
      bgColor: '#fef3c7',
      label: 'မီးသတ်ဌာန',
      iconText: '🔥'
    },
    police: {
      icon: <FaPhone />,
      color: '#3b82f6',
      bgColor: '#dbeafe',
      label: 'ရဲဌာန',
      iconText: '👮'
    },
    government: {
      icon: <FaPhone />,
      color: '#8b5cf6',
      bgColor: '#ede9fe',
      label: 'အုပ်ချုပ်ရေးမှူးရုံး',
      iconText: '🏛️'
    },
    charity: {
      icon: <FaPhone />,
      color: '#ec4899',
      bgColor: '#fce7f3',
      label: 'နာရေးကူညီမှုအသင်း',
      iconText: '🤝'
    }
  };

  // ✅ Load emergencies
  useEffect(() => {
    if (isOpen) {
      loadEmergencies();
    }
  }, [isOpen, selectedType]);

  const loadEmergencies = () => {
    setLoading(true);
    
    let allData = [];
    if (selectedType === 'all' || selectedType === 'hospital') {
      allData = [...allData, ...emergencyData.hospitals];
    }
    if (selectedType === 'all' || selectedType === 'fire') {
      allData = [...allData, ...emergencyData.fire_stations];
    }
    if (selectedType === 'all' || selectedType === 'police') {
      allData = [...allData, ...emergencyData.police_stations];
    }
    if (selectedType === 'all' || selectedType === 'government') {
      allData = [...allData, ...emergencyData.government_offices];
    }
    if (selectedType === 'all' || selectedType === 'charity') {
      allData = [...allData, ...emergencyData.charity_organizations];
    }

    if (userLocation) {
      allData = allData.map(item => {
        const distance = calculateDistance(
          userLocation.lat,
          userLocation.lng,
          item.lat,
          item.lng
        );
        return { ...item, distance: parseFloat(distance.toFixed(2)) };
      });
      allData.sort((a, b) => a.distance - b.distance);
    }

    setEmergencies(allData);
    setLoading(false);
  };

  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
      Math.sin(dLon/2) * Math.sin(dLon/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c;
  };

  // ✅ Handle Route
  const handleRoute = (emergency) => {
    console.log('📍 Route button clicked for:', emergency.name_mm);
    console.log('📍 onShowRoute function:', onShowRoute);
    
    if (onShowRoute) {
      const destination = {
        lat: emergency.lat,
        lng: emergency.lng,
        name_mm: emergency.name_mm,
        type: emergency.type
      };
      console.log('📍 Destination:', destination);
      onShowRoute(destination);
      onClose();
    } else {
      console.error('❌ onShowRoute is not defined');
      alert('လမ်းကြောင်းပြရန် မရသေးပါ။ ကျေးဇူးပြု၍ နောက်မှကြိုးစားပါ။');
    }
  };

  // ✅ Handle Call
  const handleCall = (emergency) => {
    const phone = emergency.phone || emergency.emergency_number;
    console.log('📞 Call button clicked for:', emergency.name_mm);
    console.log('📞 Phone number:', phone);
    
    if (phone && phone !== 'မရှိ') {
      const cleanPhone = phone.replace(/\s/g, '');
      const telUrl = `tel:${cleanPhone}`;
      console.log('📞 Calling:', telUrl);
      window.location.href = telUrl;
    } else {
      alert('ဖုန်းနံပါတ် မရှိပါ။');
    }
  };

  const getArrivalTime = (distance) => {
    const minutes = Math.round((distance / 30) * 60);
    return minutes;
  };

  if (!isOpen) return null;

  return (
    <div className="emergency-panel">
      {/* Header */}
      <div className="emergency-panel-header">
        <div className="emergency-panel-title">
          <span className="emergency-icon-large">🚨</span>
          <div>
            <h3>အရေးပေါ်ဌာနများ</h3>
            <p className="emergency-subtitle">အနီးဆုံးဌာနကို ရွေးချယ်ပါ</p>
          </div>
        </div>
        <button className="emergency-close-btn" onClick={onClose}>
          <FaTimes />
        </button>
      </div>

      {/* User Location */}
      {userLocation && (
        <div className="emergency-user-location">
          <FaLocationArrow className="location-icon" />
          <span>
            📍 သင့်တည်နေရာ: 
            <span className="location-coords">
              {userLocation.lat.toFixed(4)}, {userLocation.lng.toFixed(4)}
            </span>
          </span>
        </div>
      )}

      {/* Type Filter */}
      <div className="emergency-type-filters">
        <button
          className={`type-filter-btn ${selectedType === 'all' ? 'active' : ''}`}
          onClick={() => setSelectedType('all')}
        >
          အားလုံး
        </button>
        {Object.entries(typeConfig).map(([key, config]) => (
          <button
            key={key}
            className={`type-filter-btn ${selectedType === key ? 'active' : ''}`}
            style={{
              borderColor: selectedType === key ? config.color : '#e5e7eb',
              backgroundColor: selectedType === key ? config.bgColor : 'transparent'
            }}
            onClick={() => setSelectedType(key)}
          >
            <span style={{ color: config.color }}>{config.icon}</span>
            {config.label}
          </button>
        ))}
      </div>

      {/* Emergency List */}
      <div className="emergency-list-container">
        {loading ? (
          <div className="emergency-loading">
            <div className="spinner"></div>
            <p>အရေးပေါ်ဌာနများကို ရှာဖွေနေပါသည်...</p>
          </div>
        ) : emergencies.length === 0 ? (
          <div className="emergency-empty">
            <span className="empty-icon">📍</span>
            <p>အနီးအနားတွင် အရေးပေါ်ဌာနမရှိပါ။</p>
          </div>
        ) : (
          <div className="emergency-list">
            {emergencies.map((emergency, index) => {
              const arrivalTime = getArrivalTime(emergency.distance || 0);
              const typeInfo = typeConfig[emergency.type] || typeConfig.hospital;
              
              return (
                <div 
                  key={emergency.id || index} 
                  className="emergency-item"
                  style={{
                    borderLeftColor: typeInfo.color,
                    borderLeftWidth: '4px',
                    borderLeftStyle: 'solid'
                  }}
                >
                  <div className="emergency-item-header">
                    <div 
                      className="emergency-type-badge"
                      style={{
                        backgroundColor: typeInfo.bgColor,
                        color: typeInfo.color
                      }}
                    >
                      {typeInfo.iconText} {typeInfo.label}
                    </div>
                    <div className="emergency-distance">
                      📏 {emergency.distance || 'N/A'} km
                    </div>
                  </div>

                  <h4 className="emergency-name">{emergency.name_mm}</h4>
                  <p className="emergency-address">{emergency.address}</p>

                  <div className="emergency-details">
                    <div className="emergency-detail-item">
                      <span className="detail-label">📞</span>
                      <span className="detail-value">
                        {emergency.phone || emergency.emergency_number || 'မရှိ'}
                      </span>
                    </div>
                    <div className="emergency-detail-item">
                      <span className="detail-label">🕐</span>
                      <span className="detail-value">
                        {emergency.working_hours || '24/7'}
                      </span>
                    </div>
                    <div className="emergency-detail-item">
                      <span className="detail-label">⏱️</span>
                      <span className="detail-value">
                        ~{arrivalTime} မိနစ်
                      </span>
                    </div>
                    <div className="emergency-detail-item">
                      <span className="detail-label">📌</span>
                      <span className="detail-value">
                        {emergency.emergency_number || ''}
                      </span>
                    </div>
                  </div>

                  {emergency.services && emergency.services.length > 0 && (
                    <div className="emergency-services">
                      {emergency.services.map((service, idx) => (
                        <span key={idx} className="service-tag">
                          {service}
                        </span>
                      ))}
                    </div>
                  )}

                  {/* ✅ Action Buttons */}
                  <div className="emergency-actions">
                    <button
                      className="action-btn route-btn"
                      onClick={() => {
                        console.log('🔄 Route button clicked directly');
                        handleRoute(emergency);
                      }}
                      style={{
                        flex: 1,
                        padding: '10px 16px',
                        border: 'none',
                        borderRadius: '8px',
                        fontSize: '13px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        background: '#3b82f6',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        transition: 'all 0.2s'
                      }}
                    >
                      <FaDirections /> လမ်းကြောင်းပြရန်
                    </button>
                    
                    <button
                      className="action-btn call-btn"
                      onClick={() => {
                        console.log('📞 Call button clicked directly');
                        handleCall(emergency);
                      }}
                      style={{
                        flex: 1,
                        padding: '10px 16px',
                        border: 'none',
                        borderRadius: '8px',
                        fontSize: '13px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        backgroundColor: typeInfo.color || '#22c55e',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        transition: 'all 0.2s'
                      }}
                    >
                      <FaPhone /> ဆက်သွယ်ရန်
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {!loading && emergencies.length > 0 && (
          <div className="emergency-footer">
            <p>အနီးဆုံး အရေးပေါ်ဌာန {emergencies.length} ခုတွေ့ရှိပါသည်။</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmergencyPanel;